<template>
  <div class="media-intern">
    <div class="media-intern__cover"></div>
    <div class="media-intern__card">
      <div class="title">To stay tuned</div>
      <XButton class="m20" @click="openX" />
      <div class="media-intern__description">
        To create, launch, and operate agents, the user must deposit<br><span>1,000,000 SCHRDNGR</span>
      </div>
      <div class="media-intern__description">
        CA: <span>8ELspwRkgbz122WrdaX6pfHspHnLFU51jAKuP15cpump</span>
      </div>
    </div>
  </div>
</template>
<script>
import XButton from '../XButton';

export default {
  components: {
    XButton
  },
  setup() {
    const openX = () => {
      window.open("https://x.com/ai_schrodinger", "_blank");
    };

    return {
      openX,
    }
  },
}
</script>
<style lang="scss" scoped>
  .media-intern {
    font-family: 'YoungSerif-Regular';
    display: flex;
    flex-direction: column;
    width: 50%;

    .m20 {
      margin: 20px 0;
    }

    &__cover {
      border-radius: $cardRadius;
      overflow: hidden;
      min-width: 100%;
      height: clamp(200px, 32vw, 380px);
      background-size: cover;
      background-repeat: no-repeat;
      background-image: url("~@/assets/icons/catcover.jpg");
      transition: transform 0.4s ease;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      
      &:hover {
        transform: scale(1.01);
      }
    }

    &__card {
      margin-top: 15px;
      border-radius: $cardRadius;
      background-color: $panelBgColor;
      padding: clamp(25px, 3.5vw, 40px);
      display: flex;
      flex-direction: column;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
      transition: transform 0.3s ease;
      
      &:hover {
        transform: translateY(-2px);
      }

      .title {
        font-size: clamp(22px, 2.5vw, 30px);
        color: $textBlack;
        text-align: left;
        line-height: clamp(28px, 1.2em, 36px);
        font-weight: bold;
        letter-spacing: -0.5px;
      }
    }

    &__description {
      font-size: clamp(14px, 1vw, 16px);
      color: #666;
      text-align: left;
      font-weight: 500;
      margin-top: 5px;

      span {
        display: inline-block;
        margin-top: 10px;
        color: $textBlack;
        font-weight: bold;
        padding: 2px 5px;
        background: rgba(0, 0, 0, 0.02);
        border-radius: 4px;
        font-size: 14px;
        letter-spacing: 0.2px;
      }
    }

    /* Add a new media query for intermediate screen sizes */
    @media (min-width: 769px) and (max-width: 1024px) {
      width: 50%; // Keep it at 50% for medium screens
      
      &__cover {
        height: 300px; // Slightly smaller height for medium screens
      }
      
      &__card {
        padding: 30px;
        
        .title {
          font-size: 24px;
          line-height: 30px;
        }
      }
      
      &__description {
        font-size: 15px;
        
        span {
          font-size: 13px;
        }
      }
      
      /* Additional improvements for smoother scaling */
      &__card {
        transform-origin: center top;
      }
    }

    @media (max-width: $tabletSize) {
      width: 100%;

      .m20 {
        margin: 20px 0;
      }
      
      &__cover {
        border-radius: $cardRadiusMini;
        margin-top: 15px;
        height: 200px;
      }

      &__card {
        box-sizing: border-box;
        padding: 25px;
        border-radius: $cardRadiusMini;

        .title {
          font-size: 22px;
          line-height: 28px;
        }
      }

      &__description {
        font-size: 15px;

        span {
          font-size: 13px;
          word-break: break-all;
        }
      }
    }
  }
</style>
